import { apiClient } from './apiClient';

export const ROLE_IDS = {
  LEGAL: 1,
  BILLING: 2,
  PRIMARY: 3,
};

export const CONTACT_TYPES = {
  MAIN: 'Main',
};

export function isLegalRole(roleId: number) {
  return roleId === ROLE_IDS.LEGAL;
}

export function isBillingRole(roleId: number) {
  return roleId === ROLE_IDS.BILLING;
}

export function isPrimaryRole(roleId: number) {
  return roleId === ROLE_IDS.PRIMARY;
}

export type ContactRole = {
  id: number;
  name: string;
};

export type ValidateContactsPayload = {
  clientId: number;
  contacts: {
    contact: {
      firstName: string;
      lastName: string;
      dob?: string;
      ssn?: string;
      phone?: string;
      cell?: string;
      fax?: string;
      email?: string;
      ccEmails?: string[];
    };
    contactType?: number;
    contactRoles?: number[];
    startingDate?: string;
  }[];
};

export async function getContactRoles() {
  const response = (await apiClient.get('/clients/contact-roles', {})) as {
    results: ContactRole[];
  };
  return response.results;
}

export type ContactType = {
  id: number;
  name: string;
};

export async function getContactTypes() {
  const response = (await apiClient.get('/clients/contact-types', {})) as {
    results: ContactType[];
  };
  return response.results;
}

export type Contact = {
  ccEmails: string[] | null;
  cell: string | null;
  dob: string | null;
  email: string | null;
  fax: string | null;
  firstName: string | null;
  id: number;
  lastName: string | null;
  phone: string | null;
  ssn: string | null;
};

export async function getContacts() {
  const response = (await apiClient.get('/clients/contacts', {})) as {
    results: Contact[];
  };

  return response.results;
}

export const validateContacts = (
  clientId: number,
  payload: ValidateContactsPayload
): Promise<{ isValid: boolean; validationErrors?: string[] }> => {
  return apiClient.post(`clients/${clientId}/validate-contacts`, payload);
};
